<template>
  <div class="d-flex flex-column justify-center align-center">
    <p class="mb-4 text-body-1 text-center">
      {{ $t('auth.access.free_trial_expired') }}
    </p>

    <GoTo
      :linkMessage="$t('authManagePeople.go_back_to_login')"
      @onClickGoTo="$emit('goToLogin')"
    />

    <Button
      block
      class="my-5"
      data-testid="login-button-continue"
      color="primary"
      :text="$t('auth.access.contact_support')"
      @click="openSupportChat"
    />
  </div>
</template>

<script>
import Button from '@/components/UI/Button'
import GoTo from './components/GoTo.vue'

export default {
  name: 'FreeTrialExpired',

  components: {
    Button,
    GoTo,
  },

  methods: {
    openSupportChat() {
      this.$openSupportChat(this.$t('people.i_would_like_to_upgrade'))
    },
  },
}
</script>
